
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class TabNotificationBubble extends Vue {
    @Prop({ type: String || Number, default: undefined }) notification!: string | number;
    @Prop({ type: Boolean, default: true }) rounded!: boolean;
    @Prop({ type: Boolean, default: false }) info!: boolean;
    @Prop({ type: Boolean, default: false }) infoGreen!: boolean;
    @Prop({ type: Boolean, default: false }) gray!: boolean;
    @Prop({ type: Boolean, default: false }) attention!: boolean;
    @Prop({ type: Boolean, default: false }) elevated!: boolean;
    @Prop({ type: Boolean, default: false }) small!: boolean;
    @Prop({ type: Boolean, default: false }) medium!: boolean;



    get notificationStyles(): Record<string,boolean> {
      return {
        "text-sm relative bottomPosition right-1": this.elevated,
        "text-sm relative": !this.elevated,
        "rounded-full inline-flex items-center justify-center": this.rounded,
        "h-5 px-3 rounded-xl": !this.rounded,
        "bubbleWidth": !this.small && !this.medium,
        "text-base font-400 leading-normal blackCustom" : this.medium,
        "w-4 h-4": this.small,
        [this.messageColor]: true,
      };
    }

    get shape(): string {
      return this.rounded
        ? "rounded-full w-5 h-5 inline-flex items-center justify-center"
        : "h-5 px-3 rounded-xl"
    }

    get messageColor(): string {
      if (this.info) {
        return "bg-bubble-blue text-notification-blue";
      }
      if (this.infoGreen) {
        return "bg-white-100 text-white";
      }
      if (this.attention) {
        return "bg-yellow-400 text-white";
      }
      if(this.gray){
        return "bg-transparent text-nav-gray"
      }
      return "border border-primary-500";
    }
  }
